import React from 'react';
import { useLocation } from "react-router-dom";

import { Page } from "../../../_partials/Layout";
import NavBar2 from '../../../../componets/NavBar2';
import stickerMakerUrls from "../../../../configs/sticker_maker/stickerMakerUrls";
import { isActiveUrl } from "../../../../helpers/UrlHelpers";

interface PropsInterface {
  className?: string;
  children: React.ReactNode
}

const PageLayout: React.FC<PropsInterface> = (props) => {
  const PAGES: {[index: number]: any} = {
    1: {
      id: 1,
      name: 'Assets',
      icon: 'fa-regular fa-object-group',
      url: stickerMakerUrls.assetsPath()
    },
    2: {
      id: 2,
      name: 'Content',
      icon: 'fa-solid fa-grip',
      url: stickerMakerUrls.contentPath()
    },
    3: {
      id: 3,
      name: 'Community',
      icon: 'fa-solid fa-layer-group',
      url: stickerMakerUrls.communityPath()
    },
    4: {
      id: 4,
      name: 'Users',
      icon: 'fa-solid fa-users',
      url: stickerMakerUrls.usersPath()
    },
    5: {
      id: 5,
      name: 'Reports',
      icon: 'exclamation-triangle',
      url: stickerMakerUrls.reportsPath()
    },
    6: {
      id: 6,
        name: 'Reviews',
        icon: 'fa-solid fa-list-check',
        url: stickerMakerUrls.stickersReviewsPath()
    },
  };

  const PARENT_PAGE_IDS = [1, 2, 3, 6, 4, 5];
  const PAGE_IDS        = Object.keys(PAGES).map(id => parseInt(id, 10));

  const { pathname } = useLocation();
  const pageId = PAGE_IDS.find(id => isActiveUrl(PAGES[id].url, pathname));

  return (
    <Page className={props.className}>
      <NavBar2 items={PAGES} itemIds={PARENT_PAGE_IDS} activeId={pageId} />

      <div className='v-layout--body'>
        {props.children}
      </div>
    </Page>
  );
}

export default PageLayout;
